import { createSelector } from '@reduxjs/toolkit';
import { PortfolioItem } from 'scenes/reportsList/types';
import { RootState } from '..';
import { NO_BENCHMARK } from '../constants';

const portfolioState = (state: RootState) => state.portfoliosSlice;

export const portfoliosRunReport = createSelector(
  [portfolioState],
  // eslint-disable-next-line consistent-return
  (state): PortfolioItem[] => {
    if (state.portfoliosList.length <= 0) {
      return [];
    }

    return state.portfoliosList.map(
      ({ name, type, benchmarkName, portfolioId, benchmarkId }) => ({
        text: name,
        type,
        benchmarkId,
        benchmarkName,
        portfolioId,
      })
    );
  }
);

export const portfolioOptionsRunReport = createSelector(
  [portfolioState],
  // eslint-disable-next-line consistent-return
  (state): string[] => {
    const options: string[] = [];

    state.portfoliosList.forEach((item) => {
      if (item.benchmarkName && !options.includes(item.benchmarkName)) {
        options.push(item.benchmarkName);
      }
    });

    options.unshift(NO_BENCHMARK);
    return options;
  }
);
